A method of applying to a position.
